module.exports = __webpack_public_path__ + "img/bastion.b4f16f10.png";